import { cva, type VariantProps } from "class-variance-authority";
import { TiptapDisplay } from "../libs/tiptap";
import type { ChildrenProps } from "../types";

/** Props Interface */
interface CompareValueProps extends ChildrenProps, Required<VariantProps<typeof compareValue>> {}

export function CompareValue({ children, variant, width }: CompareValueProps) {
	const classes = compareValue({ variant, width });

	/** Render */
	return (
		<div className={classes}>
			<TiptapDisplay
				json={children as string}
				members={[]}
				projects={[]}
				mentionRenderers={{
					member: () => null,
					project: () => null,
				}}
			/>
		</div>
	);
}

const compareValue = cva(
	[
		"px-[3px] py-[0.5px] rounded-sm font-mono",
		"bg-linear-to-r/oklch",
		"whitespace-wrap",
		"break-all",
	],
	{
		variants: {
			variant: {
				old: ["from-red-500/8 to-red-500/5 !text-red-400"],
				new: ["from-emerald-500/8 to-emerald-500/5 !text-emerald-500"],
			},
			width: {
				"max-content": ["w-max"],
				full: ["w-full"],
			},
		},
		defaultVariants: {
			variant: "old",
			width: "max-content",
		},
	},
);
